<div class="update_profile_block change-pswd-page">
  <!-- My Account Update Profile -->
  <div class="changepass_left--slider">

    <div class="changepass_left--container">
      <div class="icon-cancel" (click)="goBack()"></div>

      <div class="changepass_left--content">

        <div class="changepass_left--content_heading myacc-pages-hdng">

          <h2 class="heading"><p>{{'updateprofileComp.updateprofile0' | translate}} </p>
            <span class="back-icn" (click)="goBack()"> 
              <small class="show-desk">✕</small>
              <i class="icon icon-arrow-2 show-mobile"></i>
            </span>
          </h2>
        </div>

        <form id="formFields" class="change-password-form" [formGroup]="changePasswordForm"
          (ngSubmit)="changePassword('changePassword')" novalidate>
          <div>
            <div class="form-group">
              <div class="controls passwrd" [ngClass]="getFormFiledClass('old',changePasswordForm)">
                <input [type]="isPwdOld ? 'text' : 'password'" (input)="trimPassowrd()" formControlName="old" name="old" id="old"
                  class="floatLabel form-control" (focus)="onFocusForElement('old')"
                  (focusout)="onFocusOutForElement()" />
                <label for="old">{{'changepwdComp.changepwd2' | translate}}</label>
              </div>
              <span class="pwd-show" [ngClass]="isPwdOld? 'eyeshow' : ''" (click)="isPwdOld = !isPwdOld"><i
                  class="icon-icon-eye"></i></span>
              <span class="pwd-show" [ngClass]="isPwdOld ? 'eyeshow' : ''" (click)="isPwdOld = !isPwdOld"><i
                  class="icon-icon-eye"></i></span>
              <div class="arrow_box" *ngIf="shouldShowErrors('old',changePasswordForm) && (changePasswordForm.controls['old'].value || isSubmitted)">
                {{getErrorMessage('old',changePasswordForm)}}</div>
            </div>

          </div>
          <div>
            <div class="form-group" [ngClass]="getFormFiledClass('password',changePasswordForm)">
              <div class="controls passwrd">
                <input [type]="isPwdNew ? 'text' : 'password'" (input)="trimPassowrd()"  formControlName="password" name="password" id="password"
                  class="floatLabel form-control pwdFloatLabel" (focus)="onFocusForElement('password')"
                  (focusout)="onFocusOutForElement()" />
                <label for="password">{{'changepwdComp.changepwd3' | translate}}</label>
              </div>
              <span class="pwd-show" [ngClass]="isPwdNew ? 'eyeshow' : ''" (click)="isPwdNew = !isPwdNew"><i
                  class="icon-icon-eye"></i></span>
              <span class="pwd-show" [ngClass]="isPwdNew ? 'eyeshow' : ''" (click)="isPwdNew = !isPwdNew"><i
                  class="icon-icon-eye"></i></span>
             
              <div  *ngIf="shouldShowPwdError('password',changePasswordForm) && (changePasswordForm.controls['password'].value || isSubmitted)"
                >
                <div class="arrow_box" *ngIf="focusPassword === true">
                  {{'phnumbertext.title' | translate}}
                </div>
                <div class="arrow_box" *ngIf="focusPassword !== true">
                  {{getErrorMessage('password',changePasswordForm)}}
                </div>
              </div>
            </div>

            <div>
              <div class="form-group" [ngClass]="getFormFiledClass('confirmPassword',changePasswordForm)">
                <div class="controls passwrd">
                  <input [type]="isPwdNewconf ? 'text' : 'password'" (input)="trimPassowrd()" formControlName="confirmPassword"
                    name="confirmPassword" id="confirmPassword" class="floatLabel form-control"
                    (focus)="onFocusForElement('confirmPassword')" (focusout)="onFocusOutForElement()" />
                  <label for="confirmPassword">{{'changepwdComp.changepwd4' | translate}}</label>
                </div>
                <span class="pwd-show" [ngClass]="isPwdNewconf ? 'eyeshow' : ''"
                  (click)="isPwdNewconf = !isPwdNewconf"><i class="icon-icon-eye"></i></span>
                <span class="pwd-show" [ngClass]="isPwdNewconf ? 'eyeshow' : ''"
                  (click)="isPwdNewconf = !isPwdNewconf"><i class="icon-icon-eye"></i></span>
                <div class="arrow_box" *ngIf="shouldShowErrors('confirmPassword',changePasswordForm) && (changePasswordForm.controls['confirmPassword'].value || isSubmitted)">
                  {{getErrorMessage('confirmPassword',changePasswordForm)}}</div>
              </div>

            </div>
          </div>

          <div class="text-center">
            <button id="changePassword" class="chnagepwd_btn btn-new site-btn site-btn__primary site-btn--lg"
              type="button" (click)="changePassword('changePassword')"
              [disabled]="isButtonDisabled(changePasswordForm)">
              <span>{{'changepwdComp.changepwd5' | translate}}</span>
            </button>
          </div>

          <div id="successTick" class="successmsg text-center" *ngIf="changePasswordSuccess">
            <p>{{'changepwdComp.changepwd6' | translate}}</p>
            
          </div>

        </form>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>